import React from "react";

export const Checkbox = ({
  field: { name, onChange, onBlur, value },
  form,
  label,
  className,
  ...props
}) => {
  return (
    <div>
      <label className="subtitle is-6">
        <input
          className={className}
          name={name}
          type="checkbox"
          value={value}
          checked={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {label}
      </label>
    </div>
  );
};
